export const SUMMER_EDITION_LOCATIONS= [
    'Açores',
    'Afrique du Sud',
    'Aland (Îles)',
    'Alaska',
    'Algérie',
    'Allemagne',
    'Andorre',
    'Angleterre',
    'Arabie Saoudite',
    'Argentine',
    'Australie',
    'Autriche',
    'Baléares (Les)',
    'Belgique',
    'Bénin',
    'Bolivie',
    'Brésil',
    'Bulgarie',
    'Cameroun',
    'Canada',
    'Canaries (Les)',
    'Cap-Vert',
    'Chine',
    'Chypre',
    'Colombie',
    'Comores',
    'Corée du Sud',
    'Corfou',
    "Côte d'Ivoire",
    'Crète',
    'Croatie',
    'Cyclades (Les)',
    'Danemark',
    'Ecosse',
    'Égypte',
    'Espagne',
    'Estonie',
    'Etats-Unis',
    'Féroé (Îles)',
    'Finlande',
    'Gibraltar',
    'Grèce',
    'Guadeloupe',
    'Guatemala',
    'Guernesey',
    'Guyane française',
    'Hawaï',
    'Honduras',
    'Hong Kong',
    'Hongrie',
    'Inde',
    'Irlande',
    'Irlande du Nord',
    'Islande',
    'Israël',
    'Italie',
    'Japon',
    'Jersey',
    'Jordanie',
    'Kazakhstan',
    'Lettonie',
    'Liechtenstein',
    'Lituanie',
    'Luxembourg',
    'Macao',
    'Madagascar',
    'Madère',
    'Malaisie',
    'Mali',
    'Malte',
    'Man (Île de)',
    'Maroc',
    'Martinique',
    'Maurice',
    'Mayotte',
    'Mexique',
    'Monténégro',
    'Norvège',
    'Nouvelle Zélande',
    'Pakistan',
    'Paraguay',
    'Pays de Galles',
    'Pays-Bas',
    'Pérou',
    'Pologne',
    'Porto Rico',
    'Portugal',
    'Qatar',
    'République Dominicaine',
    'République tchèque',
    'Réunion (Île de la)',
    'Rhodes (Île)',
    'Roumanie',
    'Russie',
    'Saint-Barthélemy',
    'Saint-Marin',
    'Saint-Martin',
    'Saint-Pierre-et-Miquelon',
    'Sardaigne',
    'Sénégal',
    'Serbie',
    'Sicile',
    'Singapour',
    'Slovaquie',
    'Slovénie',
    'Suède',
    'Suisse',
    'Thaïlande',
    'Tunisie',
    'Turquie',
    'Vatican',
    'Wight (Île de)',
];
